import type { ComponentProps } from 'react';
import { useT } from '@/i18n/useT';
import { IconButton } from '@/ui/components/IconButton';

type ToolbarButtonProps = Omit<ComponentProps<typeof IconButton>, 'hint' | 'disabled'> & {
  /** Features that are not implemented yet render disabled with an explanatory tooltip. */
  readonly available?: boolean;
};

export function ToolbarButton({ available = false, ...rest }: ToolbarButtonProps) {
  const t = useT();
  return (
    <IconButton
      {...rest}
      disabled={!available}
      {...(!available ? { hint: t('toolbar.unavailable') } : {})}
    />
  );
}
